import type { SlidesPerViewConfig } from '@/shared/lib/use-slides-per-view';

export const slidesPerViewConfig: SlidesPerViewConfig[] = [
  { max: 359, slides: (total) => (total === 1 ? 1 : 1.45) },
  { min: 360, max: 439, slides: (total) => (total === 1 ? 1.05 : 1.62) },
  { min: 440, max: 679, slides: (total) => (total < 3 ? 2 : 2.01) },
  {
    min: 680,
    max: 767,
    slides: (total) => {
      switch (total) {
        case 1:
        case 2:
          return 2;
        case 3:
          return 3;
        default:
          return 3.2;
      }
    },
  },
  {
    min: 768,
    max: 799,
    slides: (total) => {
      switch (total) {
        case 1:
        case 2:
          return 2;
        case 3:
          return 3;
        default:
          return 3.6;
      }
    },
  },
  { min: 800, max: 859, slides: (total) => (total < 5 ? 4 : 4.15) },
  { min: 860, max: 919, slides: (total) => (total < 5 ? 4 : 4.3) },
  {
    min: 920,
    max: 1023,
    slides: (total) => {
      const moreOrEqualFiveCount = total === 5 ? 5 : 5.2;

      return total < 5 ? 4 : moreOrEqualFiveCount;
    },
  },
  { min: 1024, max: 1199, slides: (total) => (total < 5 ? 4 : 5) },
  {
    min: 1200,
    slides: (total) => {
      const moreOrEqualFiveCount = total === 5 ? 5 : 6;

      return total < 5 ? 4 : moreOrEqualFiveCount;
    },
  },
];
